"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyInstructionAffirmation = exports.prepareStorage = exports.getAuthorization = exports.prepareModifyInstructionAffirmation = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const bluebird_1 = __importDefault(require("bluebird"));
const utils_1 = require("./utils");
const internal_1 = require("../../internal");
const types_1 = require("../../types");
const utils_2 = require("../../types/utils");
const utils_3 = require("../../utils");
const conversion_1 = require("../../utils/conversion");
const internal_2 = require("../../utils/internal");
/**
 * @hidden
 */
const getAssetCount = (context, instructionInfo) => {
    const { fungibleTokens: fungible, nonFungibleTokens: nonFungible, offChainAssets: offChain, } = instructionInfo;
    return (0, conversion_1.assetCountToRaw)({ fungible, nonFungible, offChain }, context);
};
/**
 * @hidden
 */
const assertPortfoliosValid = (portfolioParams, portfolios, operation) => {
    if (operation === types_1.InstructionAffirmationOperation.AffirmAsMediator ||
        operation === types_1.InstructionAffirmationOperation.RejectAsMediator ||
        operation === types_1.InstructionAffirmationOperation.WithdrawAsMediator) {
        return;
    }
    if (portfolioParams.length && portfolioParams.length !== portfolios.length) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.UnmetPrerequisite,
            message: 'Some of the portfolios are not a involved in this instruction',
        });
    }
    if (!portfolios.length) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.UnmetPrerequisite,
            message: 'The signing Identity is not involved in this Instruction',
        });
    }
};
const assertReceipts = (receipts, offChainIndices, instructionId, context) => __awaiter(void 0, void 0, void 0, function* () {
    const { polymeshApi: { query: { settlement }, }, } = context;
    const instruction = new internal_1.Instruction({ id: instructionId }, context);
    const { venue } = yield instruction.detailsFromChain();
    const allowedSigners = yield (venue === null || venue === void 0 ? void 0 : venue.getAllowedSigners());
    const invalidReceipts = [];
    const invalidSignerReceipts = [];
    const uniqueLegs = [];
    const uniqueUid = [];
    const offchainAffirmationPromises = [];
    receipts.forEach(receipt => {
        const { legId, uid, signer } = receipt;
        if (!offChainIndices.includes(legId.toNumber()) ||
            uniqueLegs.includes(legId.toNumber()) ||
            uniqueUid.includes(uid.toNumber())) {
            invalidReceipts.push(receipt);
        }
        const { address: signerAddress } = (0, internal_2.asAccount)(signer, context);
        const isAllowedSigner = allowedSigners
            ? allowedSigners.some(({ address }) => signerAddress === address)
            : false;
        if (!isAllowedSigner) {
            invalidSignerReceipts.push(receipt);
        }
        uniqueLegs.push(legId.toNumber());
        uniqueUid.push(uid.toNumber());
        offchainAffirmationPromises.push(settlement.offChainAffirmations((0, conversion_1.bigNumberToU64)(instructionId, context), (0, conversion_1.bigNumberToU64)(legId, context)));
    });
    if (invalidReceipts.length) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.UnmetPrerequisite,
            message: 'Incorrect receipt details. Note, each leg in the receipt should be mapped to unique uid',
            data: {
                invalidReceipts: JSON.stringify(invalidReceipts),
            },
        });
    }
    if (invalidSignerReceipts.length) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.UnmetPrerequisite,
            message: 'Some signers are not allowed to sign the receipt for this Instruction',
            data: {
                invalidSignerReceipts,
            },
        });
    }
    const offChainAffirmationStatuses = yield Promise.all(offchainAffirmationPromises);
    const alreadyAffirmedLegs = [];
    offChainAffirmationStatuses.forEach((status, index) => {
        if ((0, conversion_1.meshAffirmationStatusToAffirmationStatus)(status) !== types_1.AffirmationStatus.Pending) {
            alreadyAffirmedLegs.push(receipts[index].legId);
        }
    });
    if (alreadyAffirmedLegs.length) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.UnmetPrerequisite,
            message: 'Some of the legs have already been affirmed',
            data: {
                alreadyAffirmedLegs,
            },
        });
    }
    const receiptsUsedPromises = receipts.map(({ signer, uid }) => {
        const { address } = (0, internal_2.asAccount)(signer, context);
        return settlement.receiptsUsed((0, conversion_1.stringToAccountId)(address, context), (0, conversion_1.bigNumberToU64)(uid, context));
    });
    const receiptsUsed = yield Promise.all(receiptsUsedPromises);
    receiptsUsed.forEach((rawBool, index) => {
        if ((0, conversion_1.boolToBoolean)(rawBool)) {
            invalidReceipts.push(receipts[index]);
        }
    });
    if (invalidReceipts.length) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.UnmetPrerequisite,
            message: 'Some of the receipts have already been used by the receipts signers',
            data: {
                invalidReceipts,
            },
        });
    }
    return (0, conversion_1.receiptDetailsToMeshReceiptDetails)(receipts, instructionId, context);
});
/**
 * @hidden
 */
function validateMediatorStatusForAffirmation(mediatorStatus, signer, id) {
    if (mediatorStatus === types_1.AffirmationStatus.Unknown) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.ValidationError,
            message: 'The signer is not a mediator',
            data: { signer: signer.did, instructionId: id.toString() },
        });
    }
}
/**
 * @hidden
 */
function validateMediatorStatusForWithdrawl(mediatorStatus, signer, id) {
    if (mediatorStatus !== types_1.AffirmationStatus.Affirmed) {
        throw new internal_1.PolymeshError({
            code: types_1.ErrorCode.ValidationError,
            message: 'The signer is not a mediator that has already affirmed the instruction',
            data: { signer: signer.did, instructionId: id.toString() },
        });
    }
}
/**
 * @hidden
 */
function prepareModifyInstructionAffirmation(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context: { polymeshApi: { tx: { settlement: settlementTx }, query: { settlement }, call, }, }, context, storage: { portfolios, portfolioParams, senderLegAmount, totalLegAmount, signer, instructionInfo, offChainLegIndices, }, } = this;
        const { operation, id } = args, rest = __rest(args, ["operation", "id"]);
        const instruction = new internal_1.Instruction({ id }, context);
        yield Promise.all([(0, utils_1.assertInstructionValid)(instruction, context)]);
        if (!('receipts' in args)) {
            assertPortfoliosValid(portfolioParams, portfolios, operation);
        }
        const rawInstructionId = (0, conversion_1.bigNumberToU64)(id, context);
        const rawPortfolioIds = portfolios.map(portfolio => (0, conversion_1.portfolioIdToMeshPortfolioId)((0, conversion_1.portfolioLikeToPortfolioId)(portfolio), context));
        const rawDid = (0, conversion_1.stringToIdentityId)(signer.did, context);
        const multiArgs = rawPortfolioIds.map(portfolioId => (0, utils_2.tuple)(portfolioId, rawInstructionId));
        const [rawAffirmationStatuses, rawMediatorAffirmation] = yield Promise.all([
            settlement.userAffirmations.multi(multiArgs),
            settlement.instructionMediatorsAffirmations(rawInstructionId, rawDid),
        ]);
        const affirmationStatuses = rawAffirmationStatuses.map(conversion_1.meshAffirmationStatusToAffirmationStatus);
        const { status: mediatorStatus, expiry } = (0, conversion_1.mediatorAffirmationStatusToStatus)(rawMediatorAffirmation);
        const excludeCriteria = [];
        let errorMessage;
        let transaction = null;
        let rawReceiptDetails = null;
        switch (operation) {
            case types_1.InstructionAffirmationOperation.AffirmAsMediator: {
                validateMediatorStatusForAffirmation(mediatorStatus, signer, id);
                const givenExpiry = args.expiry;
                const now = new Date();
                if (givenExpiry && givenExpiry < now) {
                    throw new internal_1.PolymeshError({
                        code: types_1.ErrorCode.ValidationError,
                        message: 'The expiry must be in the future',
                        data: { expiry, now },
                    });
                }
                const rawExpiry = (0, internal_2.optionize)(conversion_1.dateToMoment)(givenExpiry, context);
                return {
                    transaction: settlementTx.affirmInstructionAsMediator,
                    resolver: instruction,
                    args: [rawInstructionId, rawExpiry],
                };
            }
            case types_1.InstructionAffirmationOperation.WithdrawAsMediator: {
                validateMediatorStatusForWithdrawl(mediatorStatus, signer, id);
                return {
                    transaction: settlementTx.withdrawAffirmationAsMediator,
                    resolver: instruction,
                    args: [rawInstructionId],
                };
            }
            case types_1.InstructionAffirmationOperation.RejectAsMediator: {
                if (mediatorStatus === types_1.AffirmationStatus.Unknown) {
                    throw new internal_1.PolymeshError({
                        code: types_1.ErrorCode.ValidationError,
                        message: 'The signer is not a mediator for the instruction',
                        data: { did: signer.did, instructionId: id.toString() },
                    });
                }
                const rawAssetCount = getAssetCount(context, instructionInfo);
                return {
                    transaction: settlementTx.rejectInstructionAsMediator,
                    resolver: instruction,
                    args: [rawInstructionId, rawAssetCount],
                };
            }
            case types_1.InstructionAffirmationOperation.Reject: {
                const rawAssetCount = getAssetCount(context, instructionInfo);
                return {
                    transaction: settlementTx.rejectInstructionWithCount,
                    resolver: instruction,
                    feeMultiplier: totalLegAmount,
                    args: [rawInstructionId, rawPortfolioIds[0], rawAssetCount],
                };
            }
            case types_1.InstructionAffirmationOperation.Affirm: {
                excludeCriteria.push(types_1.AffirmationStatus.Affirmed);
                errorMessage = 'The Instruction is already affirmed';
                const { receipts } = rest;
                if (receipts === null || receipts === void 0 ? void 0 : receipts.length) {
                    transaction = settlementTx.affirmWithReceiptsWithCount;
                    rawReceiptDetails = yield assertReceipts(receipts, offChainLegIndices, id, context);
                }
                else {
                    transaction = settlementTx.affirmInstructionWithCount;
                }
                break;
            }
            case types_1.InstructionAffirmationOperation.Withdraw: {
                excludeCriteria.push(types_1.AffirmationStatus.Pending);
                errorMessage = 'The instruction is not affirmed';
                transaction = settlementTx.withdrawAffirmationWithCount;
                break;
            }
        }
        const validPortfolioIds = rawPortfolioIds.filter((_, index) => !excludeCriteria.includes(affirmationStatuses[index]));
        if (!validPortfolioIds.length && !rawReceiptDetails) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.NoDataChange,
                message: errorMessage,
            });
        }
        const rawAffirmCount = yield call.settlementApi.getAffirmationCount(rawInstructionId, rawPortfolioIds);
        const portfolioIds = (0, conversion_1.portfolioIdsToBtreeSet)(validPortfolioIds, context);
        if (transaction === settlementTx.affirmWithReceiptsWithCount) {
            return {
                transaction,
                resolver: instruction,
                args: [rawInstructionId, rawReceiptDetails, portfolioIds, rawAffirmCount],
            };
        }
        return {
            transaction,
            resolver: instruction,
            feeMultiplier: senderLegAmount,
            args: [rawInstructionId, portfolioIds, rawAffirmCount],
        };
    });
}
exports.prepareModifyInstructionAffirmation = prepareModifyInstructionAffirmation;
/**
 * @hidden
 */
function getAuthorization(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { storage: { portfolios }, } = this;
        let transactions;
        const { operation } = args;
        switch (operation) {
            case types_1.InstructionAffirmationOperation.Affirm: {
                const { receipts } = args;
                if (receipts === null || receipts === void 0 ? void 0 : receipts.length) {
                    transactions = [types_1.TxTags.settlement.AffirmWithReceiptsWithCount];
                }
                else {
                    transactions = [types_1.TxTags.settlement.AffirmInstructionWithCount];
                }
                break;
            }
            case types_1.InstructionAffirmationOperation.Withdraw: {
                transactions = [types_1.TxTags.settlement.WithdrawAffirmationWithCount];
                break;
            }
            case types_1.InstructionAffirmationOperation.Reject: {
                transactions = [types_1.TxTags.settlement.RejectInstructionWithCount];
                break;
            }
            case types_1.InstructionAffirmationOperation.AffirmAsMediator: {
                transactions = [types_1.TxTags.settlement.AffirmInstructionAsMediator];
                break;
            }
            case types_1.InstructionAffirmationOperation.WithdrawAsMediator: {
                transactions = [types_1.TxTags.settlement.WithdrawAffirmationAsMediator];
                break;
            }
            case types_1.InstructionAffirmationOperation.RejectAsMediator: {
                transactions = [types_1.TxTags.settlement.RejectInstructionAsMediator];
                break;
            }
        }
        return {
            permissions: {
                portfolios,
                transactions,
                assets: [],
            },
        };
    });
}
exports.getAuthorization = getAuthorization;
/**
 * @hidden
 */
function extractPortfolioParams(params) {
    const { operation } = params;
    let portfolioParams = [];
    if (operation === types_1.InstructionAffirmationOperation.Reject) {
        const { portfolio } = params;
        if (portfolio) {
            portfolioParams.push(portfolio);
        }
    }
    else if (operation === types_1.InstructionAffirmationOperation.Affirm ||
        operation === types_1.InstructionAffirmationOperation.Withdraw) {
        const { portfolios } = params;
        if (portfolios) {
            portfolioParams = [...portfolioParams, ...portfolios];
        }
    }
    return portfolioParams;
}
/**
 * @hidden
 */
const isParam = (legPortfolio, portfolioIdParams) => {
    const { did: legPortfolioDid, number: legPortfolioNumber } = (0, conversion_1.portfolioLikeToPortfolioId)(legPortfolio);
    return (!portfolioIdParams.length ||
        portfolioIdParams.some(({ did, number }) => did === legPortfolioDid &&
            new bignumber_js_1.default(legPortfolioNumber || 0).eq(new bignumber_js_1.default(number || 0))));
};
/**
 * @hidden
 */
const assemblePortfolios = (result, from, to, signingDid, portfolioIdParams) => __awaiter(void 0, void 0, void 0, function* () {
    const [fromExists, toExists] = yield Promise.all([from.exists(), to.exists()]);
    const [custodiedPortfolios, amount] = result;
    let res = [...custodiedPortfolios];
    let legAmount = amount;
    const checkCustody = (legPortfolio, exists, sender) => __awaiter(void 0, void 0, void 0, function* () {
        if (exists) {
            const isCustodied = yield legPortfolio.isCustodiedBy({ identity: signingDid });
            if (isCustodied) {
                res = [...res, legPortfolio];
                if (sender) {
                    legAmount = legAmount.plus(1);
                }
            }
        }
        else if (legPortfolio.owner.did === signingDid) {
            res = [...res, legPortfolio];
        }
    });
    const promises = [];
    if (isParam(from, portfolioIdParams)) {
        promises.push(checkCustody(from, fromExists, true));
    }
    if (isParam(to, portfolioIdParams)) {
        promises.push(checkCustody(to, toExists, false));
    }
    yield Promise.all(promises);
    return (0, utils_2.tuple)(res, legAmount);
});
/**
 * @hidden
 */
function prepareStorage(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context, context: { polymeshApi }, } = this;
        const { id } = params;
        const rawId = (0, conversion_1.bigNumberToU64)(id, context);
        const portfolioParams = extractPortfolioParams(params);
        const portfolioIdParams = portfolioParams.map(conversion_1.portfolioLikeToPortfolioId);
        const instruction = new internal_1.Instruction({ id }, context);
        const [{ data: legs }, signer, executeInstructionInfo] = yield Promise.all([
            instruction.getLegsFromChain(),
            context.getSigningIdentity(),
            polymeshApi.call.settlementApi.getExecuteInstructionInfo(rawId),
        ]);
        const [portfolios, senderLegAmount, offChainLegIndices] = yield bluebird_1.default.reduce(legs, (result, leg, index) => __awaiter(this, void 0, void 0, function* () {
            let [custodiedPortfolios, legAmount, offChainLegs] = result;
            if ((0, utils_3.isOffChainLeg)(leg)) {
                offChainLegs.push(index);
            }
            else {
                const { from, to } = leg;
                [custodiedPortfolios, legAmount] = yield assemblePortfolios((0, utils_2.tuple)(custodiedPortfolios, legAmount), from, to, signer.did, portfolioIdParams);
            }
            return (0, utils_2.tuple)(custodiedPortfolios, legAmount, offChainLegs);
        }), [[], new bignumber_js_1.default(0), []]);
        const rawInfo = executeInstructionInfo;
        const instructionInfo = rawInfo.unwrapOrDefault();
        return {
            portfolios,
            portfolioParams,
            senderLegAmount,
            totalLegAmount: new bignumber_js_1.default(legs.length),
            signer,
            offChainLegIndices,
            instructionInfo,
        };
    });
}
exports.prepareStorage = prepareStorage;
/**
 * @hidden
 */
const modifyInstructionAffirmation = () => new internal_1.Procedure(prepareModifyInstructionAffirmation, getAuthorization, prepareStorage);
exports.modifyInstructionAffirmation = modifyInstructionAffirmation;
//# sourceMappingURL=modifyInstructionAffirmation.js.map